import '../sass/home.scss';


document.addEventListener('DOMContentLoaded', () => {

    const heroBox = document.querySelector('.hero__info');
    heroBox.classList.add('animate__animated', 'animate__fadeInLeft');


    const heroLinks = document.querySelector('.hero__links');
    heroLinks.classList.add('animate__animated', 'animate__fadeInRight');

    const header = document.querySelector('.header');
    header.classList.add('animate__animated', 'animate__fadeInDown');
});